import { Container as MapDiv, NaverMap } from 'react-naver-maps';
import { useParams } from 'react-router';

import { SaveStationButton } from '@/features/favorites-toggle';
import {
	NavigationButtonGroup,
	PriceInfo,
	StationInfo,
	useStationPageData,
} from '@/features/station';
import { PlaceMarker } from '@/widgets/naver-map';

const StationDetailContent = () => {
	const { stationId } = useParams();
	const {
		gasStation,
		stationLocation,
		distance,
		regionPrice,
		gasolinePrice,
		dieselPrice,
		gasolineAverage,
		dieselAverage,
		launchNavigationApp,
	} = useStationPageData(stationId);

	return (
		<>
			<MapDiv style={{ width: '100%', height: 240 }}>
				<NaverMap
					center={{
						lat: stationLocation?.lat || 0,
						lng: stationLocation?.lng || 0,
					}}
					disableDoubleClickZoom
					disableDoubleTapZoom
					disableTwoFingerTapZoom
					draggable={false}
				>
					<PlaceMarker lat={stationLocation?.lat} lng={stationLocation?.lng} />
				</NaverMap>
			</MapDiv>
			<div className="flex flex-col items-center p-5">
				<StationInfo
					stationName={gasStation?.OS_NM}
					address={gasStation?.NEW_ADR}
					phone={gasStation?.TEL}
					distance={distance}
					actionSlot={
						gasStation?.UNI_ID ? (
							<SaveStationButton stationId={gasStation.UNI_ID} />
						) : undefined
					}
				/>
				<section className="flex self-stretch px-1 py-2">
					<PriceInfo
						fuelType="휘발유"
						currentPrice={gasolinePrice}
						averagePrice={gasolineAverage}
						region={regionPrice?.sido}
					/>
					<PriceInfo
						fuelType="경유"
						currentPrice={dieselPrice}
						averagePrice={dieselAverage}
						region={regionPrice?.sido}
					/>
				</section>
				<p className="py-2 font-light text-[10px] text-mantang-gray-500">
					2026.04.06 17시에 업데이트된 가격이에요
				</p>
				<div className="mt-2 self-stretch">
					<NavigationButtonGroup onNavigate={launchNavigationApp} />
				</div>
			</div>
		</>
	);
};

export default StationDetailContent;
